import React, { forwardRef, useState, useRef } from "react";
import PropTypes from "prop-types";
import { useSpring, animated, config } from "react-spring/web.cjs";
import { useDrag } from "react-use-gesture";
import useWindowDimensions from "./useWindowDimensions";
import useElementDimensions from "./useElementDimensions";

import styles from "./GlobalFooter.scss";

const GlobalFooterCertificates = forwardRef((props, ref) => {
  const { children, isVisible } = props;
  const [x, setX] = useState(0);

  if (!children || !isVisible) {
    return "";
  }

  const scrollerRef = useRef(null);
  const { windowWidth } = useWindowDimensions();
  const { width: scrollerWidth } = useElementDimensions(scrollerRef);

  const transform = useSpring({
    from: { transform: "translate(0px)" },
    transform: `translate(${x}px)`,
    config: config.default,
  });

  if (scrollerWidth - windowWidth >= 0) {
    if (x < -1 * (scrollerWidth - windowWidth)) {
      setX(-1 * (scrollerWidth - windowWidth));
    }
  }

  const bind = useDrag(
    ({ offset: [offsetX] }) => {
      if (scrollerWidth > windowWidth) {
        setX(offsetX);
      }
    },
    {
      bounds: { left: -1 * (scrollerWidth - windowWidth), right: 0 },
      rubberband: true,
    }
  );

  return (
    <div ref={ref} className={styles["certificates-section"]}>
      <animated.div
        className={styles["certificates-scroll-track"]}
        ref={scrollerRef}
        {...bind()}
        style={windowWidth < 1024 ? transform : { transform: "translate(0px)" }}
      >
        {children}
      </animated.div>
    </div>
  );
});

GlobalFooterCertificates.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  isVisible: PropTypes.bool,
};

GlobalFooterCertificates.defaultProps = {
  isVisible: true,
};

GlobalFooterCertificates.displayName = "GlobalFooter.Certificates";

export default GlobalFooterCertificates;
